// Route helpers for the Networks reference (/networks/:slug?impl=<chain slug>).
// The network comes from the path; the selected Datanodes implementation
// (Tendermint RPC vs REST, …) from the `impl` search param so links stay
// shareable. Shared by the page body and the sidebar.
import { useCallback, useMemo } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getNetwork } from "../data/apiReference";

export const NETWORKS_PATH = "/networks";

export const networkPath = (networkSlug, implSlug) =>
  `${NETWORKS_PATH}/${networkSlug}${implSlug ? `?impl=${implSlug}` : ""}`;

// Resolve the active network + implementation from the current location.
export const useNetworkRoute = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const routeSlug = location.pathname.startsWith(`${NETWORKS_PATH}/`) ? location.pathname.split("/")[2] : null;
  const resolved = useMemo(() => (routeSlug ? getNetwork(routeSlug) : null), [routeSlug]);
  const network = resolved?.network || null;

  const implParam = params.get("impl");
  const impl = useMemo(() => {
    if (!network) return null;
    return network.chains.find((c) => c.slug === implParam) || resolved.chain || network.chains[0];
  }, [network, implParam, resolved]);

  const setImpl = useCallback(
    (chainSlug) => {
      if (!network) return;
      const first = network.chains[0]?.slug;
      navigate(networkPath(network.slug, chainSlug === first ? null : chainSlug), { replace: true });
    },
    [navigate, network],
  );

  return { routeSlug, network, impl, setImpl, isIndex: location.pathname === NETWORKS_PATH };
};
